export const VUE_CLI_DEVELOPMENT_ENVIRONMENT = 'development'
export const VUE_CLI_SANDBOX_ENVIRONMENT = 'sandbox'
export const VUE_CLI_PRODUCTION_ENVIRONMENT = 'production'

export const isNotADevelopmentEnvironment = () =>
  process.env.NODE_ENV !== VUE_CLI_DEVELOPMENT_ENVIRONMENT

export const isNotProductionLikeEnvironment = () => {
  return (
    process.env.NODE_ENV !== VUE_CLI_SANDBOX_ENVIRONMENT &&
    process.env.NODE_ENV !== VUE_CLI_PRODUCTION_ENVIRONMENT
  )
}
